const CtaPositioning = {
  bottomLeft: 'BottomLeft',
  bottomCenter: 'BottomCenter',
};

export default CtaPositioning;
